import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, homeRoute } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Availability from "./pages/Availability";
import VehicleDetail from "./pages/VehicleDetail";
import BlockCar from "./pages/BlockCar";
import Approvals from "./pages/Approvals";
import Trips from "./pages/Trips";
import TripDetail from "./pages/TripDetail";
import SecurityScan from "./pages/SecurityScan";
import SecurityHistory from "./pages/SecurityHistory";
import CalendarView from "./pages/CalendarView";
import Workshop from "./pages/Workshop";
import Fuel from "./pages/Fuel";
import Damage from "./pages/Damage";
import Compliance from "./pages/Compliance";
import Accounts from "./pages/Accounts";
import Dashboard from "./pages/Dashboard";
import Leaderboard from "./pages/Leaderboard";
import Exceptions from "./pages/Exceptions";
import Admin from "./pages/Admin";
import Transfers from "./pages/Transfers";
import MDDashboard from "./pages/MDDashboard";
import Notifications from "./pages/Notifications";
import VehicleMaster from "./pages/VehicleMaster";
import TDSummary from "./pages/TDSummary";
import SecurityOutNow from "./pages/SecurityOutNow";
import ForcePassword from "./pages/ForcePassword";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePassword />;
  return <Layout>{children}</Layout>;
}

function RoleHome() {
  const { user } = useAuth();
  return <Navigate to={homeRoute(user.role)} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><RoleHome /></Protected>} />
            <Route path="/board" element={<Protected><Availability /></Protected>} />
            <Route path="/vehicle/:id" element={<Protected><VehicleDetail /></Protected>} />
            <Route path="/block/:vehicleId?" element={<Protected><BlockCar /></Protected>} />
            <Route path="/approvals" element={<Protected><Approvals /></Protected>} />
            <Route path="/trips" element={<Protected><Trips /></Protected>} />
            <Route path="/trip/:id" element={<Protected><TripDetail /></Protected>} />
            <Route path="/scan" element={<Protected><SecurityScan /></Protected>} />
            <Route path="/scan/history" element={<Protected><SecurityHistory /></Protected>} />
            <Route path="/scan/out" element={<Protected><SecurityOutNow /></Protected>} />
            <Route path="/calendar" element={<Protected><CalendarView /></Protected>} />
            <Route path="/workshop" element={<Protected><Workshop /></Protected>} />
            <Route path="/fuel" element={<Protected><Fuel /></Protected>} />
            <Route path="/damage" element={<Protected><Damage /></Protected>} />
            <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
            <Route path="/accounts" element={<Protected><Accounts /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/leaderboard" element={<Protected><Leaderboard /></Protected>} />
            <Route path="/exceptions" element={<Protected><Exceptions /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/transfers" element={<Protected><Transfers /></Protected>} />
            <Route path="/md" element={<Protected><MDDashboard /></Protected>} />
            <Route path="/fleet-master" element={<Protected><VehicleMaster /></Protected>} />
            <Route path="/td-summary" element={<Protected><TDSummary /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
